// NewsSection.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const NewsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          {/* Left Side */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block bg-surface text-secondary text-xs font-light px-6 py-2 rounded-full mb-4">
              Writing
            </span>
            <h2 className="text-3xl md:text-4xl font-semibold text-primary">
              Notes and Guides
            </h2>
          </motion.div>
          
          {/* Right Side */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="flex flex-col justify-center"
          >
            <p className="text-gray-600 text-sm font-light leading-relaxed mb-4">
              We write up the questions clients ask us most: what a shortlist should look like, how long a visa realistically takes, what an overseas employer expects to see in an interview, and where the money actually goes.
            </p>
            <p className="text-gray-600 text-sm font-light leading-relaxed mb-6">
              Each piece is written to be read once and used, without the jargon that tends to surround this subject.
            </p>
            <Link 
              to="/blog" 
              className="text-primary text-sm font-normal border-b border-primary pb-1 hover:opacity-80 transition inline-block w-fit"
            >
              Read the latest
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
